const dashboardView = {

	init() {

		// Functie voor het uitbreiden en samenvouwen van documentatie-items
		document.querySelectorAll('.accordion-header').forEach(function(element) {
			element.addEventListener('click', function(event) {
				event.preventDefault();
				dashboardView.toggleDocumentatie(event);
			});
		});

		// Functie voor het tonen van een toestemming modal
		document.querySelectorAll('[data-target-modal]').forEach(function(element) {
			element.addEventListener('click', function(event) {
				event.preventDefault();
				dashboardView.openTargetModal(event);
			});
		});
	},

	// Bind functie voor het in en uitklappen van documentatie items aan panel
	toggleDocumentatie: function(event) {
		// Define dom targets and css classes
		let arrow = document.querySelector(event.target).parentNode.querySelector('span.rotation-arrow');
		let group = Array.from(document.querySelector(event.target).closest('.panel-group').querySelectorAll('.panel > .panel-heading > a > small > span.rotation-arrow'));
		let right = 'fa-chevron-right';
		let down = 'fa-chevron-down';
		if (arrow.classList.contains(down)) {
			// If arrow is pointing down, close all others, remove the 'down' class and add 'right' class
			group.forEach(function(element) {
				element.classList.add(right);
				element.classList.remove(down);
			});
			arrow.classList.remove(down);
			arrow.classList.add(right);
		} else if (arrow.classList.contains(right)) {
			// If arrow is pointing right, close all others, remove the 'right' class add 'down' class
			group.forEach(function(element) {
				element.classList.add(right);
				element.classList.remove(down);
			});
			arrow.classList.remove(right);
			arrow.classList.add(down);
		}
	},

	// Bind functie tonen van een toestemming modal
	openTargetModal: function(event) {
		let target = event.target.getAttribute('data-target-modal');
		let element = document.getElementById(target);
		let modal = new bootstrap.Modal(element, {});
		modal.show();
	},
};

export default dashboardView;
